const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getConfig() {
  const config: Record<string, string> = (window as any)[CONFIG_KEY] || {};
  return {
    SEGMENT_ID: config['SEGMENT_ID'] || '',
    AUTH0_DOMAIN: config['AUTH0_DOMAIN'] || '',
    API_NOTIFICATION_PATH: config['API_NOTIFICATION_PATH'] || '/api/notification-api',
    API_PREFERENCE_PATH: config['API_PREFERENCE_PATH'] || '/preference-filters',
    API_PERSONA_PATH: config['API_PERSONA_PATH'] || '/api/persona',
    API_USER_API_PATH: config['API_USER_API_PATH'] || '/api/users-api',
  };
}

type Config = ReturnType<typeof getConfig>;

export { getConfig, CONFIG_KEY, Config };
